"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayResultsBar", {
  enumerable: true,
  get: function get() {
    return _ResultsBar.default;
  }
});
exports.default = void 0;

var _ManagementToolbar = _interopRequireDefault(require("./ManagementToolbar"));

var _ResultsBar = _interopRequireDefault(require("./ResultsBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * @deprecated since version 3.54.x.
 */
var _default = _ManagementToolbar.default;
exports.default = _default;